export default {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  USER: '/users',
  CONFIG_APP: '/timeline/auth',
  CONFIG_DB: '/timeline/setting',
  USER_REGISTER: '/auth/register',
  MEMBER: '/users',
  UPDATE_MEMBER: '/users/:id',
  TAG: '/common/tags',
  ATTRIBUTE: '/common/face-attribute',
  GET_CHARTS: '/get-charts',
  FACE_ID: '/face-ids',
  UPDATE_FACE_ID: 'face-ids/:dbType/:id',
  FACE_DB: '/timeline/databases',
  GET_FACE_IDS_CHART: '/chart/face-ids',
};
